// extracted by mini-css-extract-plugin
module.exports = {"activity-actions-bar":"activity-actions-bar___1Ibg0","activity-action":"activity-action___3PUiY","action-icon":"action-icon___2AS8m","flagged":"flagged___2W0b4"};